// SPEC-55 · the laterality question in English (see laterality.ts), British
// spelling, informal "you" as in the rest of the app. A fighter is asked her
// stance, the word English uses for a boxer's or a judoka's guard. The
// founder validates this text before prod.

import type { LateralityDictionary } from "./laterality";

export const LATERALITY_EN: LateralityDictionary = {
  pe: {
    question: "Which foot do you shoot with?",
    label: "Dominant foot",
    options: { "pe-direito": "Right foot", "pe-esquerdo": "Left foot", "os-dois": "Both" },
  },
  impulsao: {
    question: "Which is your take-off leg?",
    label: "Take-off leg",
    options: { "perna-direita": "Right leg", "perna-esquerda": "Left leg", "nao-sei": "I don’t know" },
  },
  guarda: {
    question: "What’s your stance?",
    label: "Stance",
    options: { ortodoxa: "Orthodox (left foot forward)", canhota: "Southpaw (right foot forward)", troco: "I switch stance" },
  },
  mao: {
    question: "Which hand do you throw or hit with?",
    label: "Dominant hand",
    options: { "mao-direita": "Right hand", "mao-esquerda": "Left hand", "as-duas": "Both" },
  },
  apoio: {
    question: "Which is your supporting leg?",
    label: "Supporting leg",
    options: { "perna-direita": "Right leg", "perna-esquerda": "Left leg", "as-duas": "Both" },
  },
  geral: {
    question: "Are you right- or left-handed?",
    label: "Handedness",
    options: { destra: "Right-handed", canhota: "Left-handed", ambidestra: "Ambidextrous" },
  },
};
